import React, { useRef } from "react";

// Hooks
import { useTranslation } from "react-i18next";

// Styles
import "cropperjs/dist/cropper.css";
import "./Cropper.scss";

// Components
import { IonButton, IonButtons, IonContent, IonHeader, IonModal, IonTitle, IonToolbar } from "@ionic/react";
import AdvancedCropper, { ReactCropperElement, ReactCropperProps } from "react-cropper";
import {debug} from "../../App";

interface CropperProps {
  image: string;
  setImage: any;
  isOpen: boolean;
  options: ReactCropperProps;
  closeCropper: () => void;
  circle: boolean;
}

export default function Cropper({ image, setImage, closeCropper, isOpen, options, circle }: CropperProps) {
  const cropperRef = useRef<ReactCropperElement>(null);
  const { t } = useTranslation();

  return (
    <IonModal isOpen={isOpen}>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={closeCropper}>{t("cancel")}</IonButton>
          </IonButtons>
          <IonButtons slot="end">
            <IonButton onClick={cropImage}>{t("save")}</IonButton>
          </IonButtons>
          <IonTitle>{t("cropPhoto")}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent className={"ion-padding vertical-center"}>
        <div className={"cropper__container" + (circle ? " cropper__container--circle" : "")}>
          {/* @ts-ignore */}
          <AdvancedCropper dragMode="move" guides={false} src={image} crossOrigin="anonymous" checkCrossOrigin={true} ref={cropperRef} className="cropper__component" height={400} {...options} />
        </div>
      </IonContent>
    </IonModal>
  );

  function getRoundedCanvas(sourceCanvas: HTMLCanvasElement) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (!context) {
      return sourceCanvas;
    }

    const width = sourceCanvas.width;
    const height = sourceCanvas.height;

    canvas.width = width;
    canvas.height = height;
    canvas.onerror = (err) => {
      debug('Error creating canvas', err);
    };
    context.imageSmoothingEnabled = true;
    context.drawImage(sourceCanvas, 0, 0, width, height);
    context.globalCompositeOperation = "destination-in";
    context.beginPath();
    context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
    context.fill();
    return canvas;
  }

  function cropImage() {
    if (!cropperRef.current) return;
    closeCropper();

    setTimeout(async () => {
      const cropper = cropperRef.current?.cropper;
      let croppedCanvas = cropper?.getCroppedCanvas();

      if(croppedCanvas) {
        croppedCanvas.onerror = (err) => {
          debug('Error cropping canvas', err);
        }
      } else {
        debug('Error cropping canvas: croppedCanvas is null');
      }

      if (0 && circle) {
        croppedCanvas = getRoundedCanvas(croppedCanvas!);
      }

      // server will convert to jpeg / webp etc
      setImage(croppedCanvas?.toDataURL("image/png"));
    }, 250);
  }
}
